/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_Entitlementname1Inputs */

const id_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Hak`)
};

const ms_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Hak`)
};

const da_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rettighedsnavn`)
};

const de_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungsname`)
};

const en_us2_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitlement Name`)
};

const es_es2_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del derecho`)
};

const es_mx2_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del derecho`)
};

const fil_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan ng Entitlement`)
};

const fr_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du droit`)
};

const it_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome diritto`)
};

const hu_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogosultság neve`)
};

const nl_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtnaam`)
};

const no_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rettighetsnavn`)
};

const pl_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa uprawnienia`)
};

const pt_br2_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do direito`)
};

const pt_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do direito`)
};

const ro_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nume drept`)
};

const fi_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeuden nimi`)
};

const sv_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rättighetsnamn`)
};

const vi_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên quyền`)
};

const tr_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetki Adı`)
};

const cs_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název oprávnění`)
};

const bg_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Име на права`)
};

const ru_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя права`)
};

const uk_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва права`)
};

const ar_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم الحق`)
};

const hi_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एंटाइटलमेंट नाम`)
};

const th_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อสิทธิ์`)
};

const ja_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権利名`)
};

const zh_cn2_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权名称`)
};

const zh_hant1_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授權名稱`)
};

const ko_items_table_entitlementname1 = /** @type {(inputs: Items_Table_Entitlementname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권한 이름`)
};

/**
* | output |
* | --- |
* | "Entitlement Name" |
*
* @param {Items_Table_Entitlementname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_entitlementname1 = /** @type {((inputs?: Items_Table_Entitlementname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_Entitlementname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_entitlementname1(inputs)
	if (locale === "ms") return ms_items_table_entitlementname1(inputs)
	if (locale === "da") return da_items_table_entitlementname1(inputs)
	if (locale === "de") return de_items_table_entitlementname1(inputs)
	if (locale === "en-US") return en_us2_items_table_entitlementname1(inputs)
	if (locale === "es-ES") return es_es2_items_table_entitlementname1(inputs)
	if (locale === "es-MX") return es_mx2_items_table_entitlementname1(inputs)
	if (locale === "fil") return fil_items_table_entitlementname1(inputs)
	if (locale === "fr") return fr_items_table_entitlementname1(inputs)
	if (locale === "it") return it_items_table_entitlementname1(inputs)
	if (locale === "hu") return hu_items_table_entitlementname1(inputs)
	if (locale === "nl") return nl_items_table_entitlementname1(inputs)
	if (locale === "no") return no_items_table_entitlementname1(inputs)
	if (locale === "pl") return pl_items_table_entitlementname1(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_entitlementname1(inputs)
	if (locale === "pt") return pt_items_table_entitlementname1(inputs)
	if (locale === "ro") return ro_items_table_entitlementname1(inputs)
	if (locale === "fi") return fi_items_table_entitlementname1(inputs)
	if (locale === "sv") return sv_items_table_entitlementname1(inputs)
	if (locale === "vi") return vi_items_table_entitlementname1(inputs)
	if (locale === "tr") return tr_items_table_entitlementname1(inputs)
	if (locale === "cs") return cs_items_table_entitlementname1(inputs)
	if (locale === "bg") return bg_items_table_entitlementname1(inputs)
	if (locale === "ru") return ru_items_table_entitlementname1(inputs)
	if (locale === "uk") return uk_items_table_entitlementname1(inputs)
	if (locale === "ar") return ar_items_table_entitlementname1(inputs)
	if (locale === "hi") return hi_items_table_entitlementname1(inputs)
	if (locale === "th") return th_items_table_entitlementname1(inputs)
	if (locale === "ja") return ja_items_table_entitlementname1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_entitlementname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_entitlementname1(inputs)
	return ko_items_table_entitlementname1(inputs)
});
export { items_table_entitlementname1 as "items.table.entitlementName" }